import { render, staticRenderFns } from "./OrderNumberItem.vue?vue&type=template&id=c0090cd2&scoped=true&"
import script from "./OrderNumberItem.vue?vue&type=script&lang=js&"
export * from "./OrderNumberItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderNumberItem.vue?vue&type=style&index=0&id=c0090cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0090cd2",
  null
  
)

export default component.exports